<template>
  <div class="breadpay-page__content">
    <div class="bread-header">
      <div class="bread-title">
        <h1>Pay over time</h1>
        <p>We've partnered with <strong>Bread Pay®</strong> so you can buy what you want now and pay later at a pace
          that works for you.</p>
        <div class="bread-title-cta"><button id="bread-placement" class="bread-button-primary" type="button"> See if you
            prequalify </button></div>
      </div>
      <div class="bread-hero bread-w-full"><img alt="Pay over time"
          src="https://assets.platform.breadpayments.com/dynamic-financing/headline.png" class=""></div>
    </div>
    <!-- Payment plans -->
    <div class="bread-payment-plans">
      <div id="payment-plan" class="payment-plan"></div>
    </div>
    <!-- Loan terms -->
    <div class="bread-loan-terms">
      <div class="bread-terms-section">
        <div class="bread-terms-icon"><object
            data="https://assets.platform.breadpayments.com/dynamic-financing/simple-application-icon.svg"
            type="image/svg+xml"></object></div>
        <div class="bread-terms-content">
          <h2>Simple application</h2>
          <p>Get a decision in seconds without affecting your credit score.</p>
        </div>
      </div>
      <div class="bread-terms-section">
        <div class="bread-terms-icon"><object
            data="https://assets.platform.breadpayments.com/dynamic-financing/pricing-icon.svg"
            type="image/svg+xml"></object></div>
        <div class="bread-terms-content">
          <h2>Straightforward pricing</h2>
          <p>What you see is what you get. No hidden fees, prepayment penalties or compound interest.</p>
        </div>
      </div>
      <div class="bread-terms-section">
        <div class="bread-terms-icon"><object
            data="https://assets.platform.breadpayments.com/dynamic-financing/pay-icon.svg"
            type="image/svg+xml"></object></div>
        <div class="bread-terms-content">
          <h2>Pay at your own pace</h2>
          <div id="loan-terms"></div>
        </div>
      </div>
    </div>
    <div class="bread-get-your-rate"><button class="bread-button-primary" id="get-rate-button" type="button"> Get your
        rate </button></div>
    <!-- Financing made easy -->
    <div class="bread-financing-made-easy">
      <div class="bread-financing-made-easy-content">
        <h1>Financing made easy</h1>
        <div class="bread-financing-made-easy-items">
          <div class="bread-financing-made-easy-item bread-financing-step-one">
            <h2>Step 1</h2>
            <p class="step-subtext">Shop our website</p>
            <p>Add items to your cart. Choose Bread Pay® and get a real-time decision without affecting your credit
              score.</p>
          </div>
          <div class="bread-financing-made-easy-item bread-financing-step-two">
            <h2>Step 2</h2>
            <p class="step-subtext">Select your plan</p>
            <p>Pick the option that works for your budget.</p>
          </div>
          <div class="bread-financing-made-easy-item bread-financing-step-three">
            <h2>Step 3</h2>
            <p class="step-subtext">Complete your purchase</p>
            <p>Get your items now and pay over time.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Questions -->
    <div class="bread-questions">
      <h2 class="">Still have questions?</h2>
      <a href="https://www.breadfinancial.com/en/help-center.html" class="bread-link-button" target="_blank">Help
        center</a>
    </div>
    <!-- Disclosures -->
    <div id="disclosure" class="bread-disclosures"></div>
    <!-- Footer -->
    <div class="bread-footer"><object data="https://assets.platform.breadpayments.com/dynamic-financing/bread-logo.svg"
        type="image/svg+xml"></object></div>
  </div>
</template>

<script>

/**
 * Vue: Recommended products (blade-recommended)
 * -----------------------------------------------------------------------------
 * Cross sell module to recommend products.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */



export default {
  name: 'BreadpayPage',

  props: {

    html:
    {
      type: String,
      default: null,
    },
    pagehtml:
    {
      type: String,
      default: null,
    },
  },

  data() {
    return {
    }
  },

  mounted() {
    window.BreadFinancing.setup({
              merchantId: '203cbdf0-6e71-42f7-bd7d-b7142d767ba1'
            });

            window.BreadFinancing.renderToContainers({
              paymentPlanContainerId: 'payment-plan',
              loanTermsContainerId: 'loan-terms',
              disclosureContainerId: 'disclosure',
            });

//            // Bread SDK setup
//            var placement = {
//              allowCheckout: false,
//              domID: 'bread-placement',
//            };
//
//            window.BreadPayments.setup({
//              integrationKey: '4ad64e7a-d472-4404-bf33-e7ff260ec543',
//            });
//          
//          
//            window.BreadPayments.registerPlacements([placement]);
//            window.BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', () => { });
//            window.BreadPayments.on('INSTALLMENT:APPLICATION_DECISIONED', () => { });
//
//            function openBreadExperience(e) {
//              e.preventDefault();
//              console.log('placement',placement)
//              console.log('placement',   BreadPayments.openExperienceForPlacement)
//              window.BreadPayments.openExperienceForPlacement([placement]);
//            }
//
//            const preQualifyButtonEl = document.getElementById('bread-placement');
//            console.log('bread-button')
//            preQualifyButtonEl.addEventListener('click', openBreadExperience);
//
//            const getYourRateButtonEl = document.getElementById('get-rate-button');
//            console.log('rate-button')
//            getYourRateButtonEl.addEventListener('click', openBreadExperience);
  },

}
</script>

<style lang="scss">
// @import './breadpay-page';
@import './breadpay-page.scss';
</style>